module.exports = __webpack_public_path__ + "9543992dfdaf2fd8cdecf3810ccd8bce.jpg";